<template>
  <client-only>
    <div>
      <v-row>
        <v-col class="py-0" style="position: relative">
          <v-combobox
            ref="combobox"
            v-model="model"
            v-on="$listeners"
            v-bind="$attrs"
            :loading="isLoading"
            :items="cities"
            :search-input.sync="search"
            :placeholder="placeholder"
            class="pa-0 location-select"
            item-text="NameInHebrew"
            item-value="Code"
            solo
            background-color="transparent"
            outlined
            flat
            dense
            :rounded="isRounded"
            :prepend-inner-icon="'icon-forma-1-4'"
            append-icon
            required
            hide-details
            @keydown="onLocaionKeypress"
            @update:search-input="fetchPlaces"
            :menu-props="{
              contentClass: 'smart-combo scrollbar-17',
              maxHeight: '200',
            }"
          ></v-combobox>
          <v-col id="range-select" v-show="model || select">
            <v-select
              append-icon="mdi-menu-down"
              :items="distanceItems"
              v-model="distanceModel"
              class="px-0 display-12"
              item-value="Code"
              item-text="NameInHebrew"
              solo
              dense
              return-object
              cy-data="cy-range-select"
              hide-details
            ></v-select>
          </v-col>
        </v-col>
      </v-row>
    </div>
  </client-only>
</template>

<script>
import debounce from 'lodash/debounce';
import { locationRules } from '@/lib/rules';
import { CITY_AUTO_COMPLETE } from '@/lib/api.js';
import isObject from 'lodash/isObject';

export default {
  name: 'LocationWithRange',
  props: {
    placeholder: {
      type: String,
      default: '',
    },
    isRounded: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectedLocation: {
      type: Object,
      required: false,
      default: () => {},
    },
    selectedRange: {
      type: Object,
      required: false,
      default: () => {},
    },
  },

  data() {
    return {
      search: null,
      distanceItems: [
        { Code: 1, NameInHebrew: '5 ק"מ' },
        { Code: 2, NameInHebrew: '10 ק"מ' },
        { Code: 7, NameInHebrew: '20 ק"מ' },
        { Code: 3, NameInHebrew: '30 ק"מ' },
        { Code: 4, NameInHebrew: '50 ק"מ' },
        { Code: 8, NameInHebrew: '70 ק"מ' },
        { Code: 5, NameInHebrew: '100 ק"מ' },
        { Code: 6, NameInHebrew: '150 ק"מ' },
      ],
      select: null,
      defaultRange: { Code: 3, NameInHebrew: '30 ק"מ' },
      selectedDistanceRange: '',
      isLoading: false,
      cities: [],
      formLabel: 'ישוב',
      locationRules,
    };
  },

  computed: {
    model: {
      get() {
        return this.selectedLocation
          ? this.selectedLocation?.NameInHebrew
          : null;
      },
      set(val) {
        this.select = val;
      },
    },
    distanceModel: {
      get() {
        return this.selectedRange ? this.selectedRange : this.defaultRange;
      },
      set(val) {
        this.selectedDistanceRange = val;
      },
    },
  },

  mounted() {
    this.fetchPlaces = debounce(this.fetchPlaces, 200);
  },

  watch: {
    select(val) {
      if (this.selectedLocation && !val) this.$emit('updateLocation', null);
      else if (isObject(val)) this.$emit('updateLocation', val);
      else this.$emit('deleteLocation');
    },

    search() {
      if (this.search) this.fetchPlaces(this.search);
    },
    selectedLocation(val) {
      this.model = this.selectedLocation;
      this.$emit('updateLocation', val);
    },
    selectedDistanceRange(val) {
      this.$emit('distanceSelected', val);
    },
  },
  methods: {
    onLocaionKeypress() {
      this.$emit('resetBtn', true);
    },
    fetchPlaces() {
      if (this.isLoading) return;
      this.isLoading = true;

      try {
        this.$axios
          .get(
            `${CITY_AUTO_COMPLETE}/?cityautocomplete=${this.search}&issmartagent=true`
          )
          .then((res) => {
            if (res.data.IsError) {
              throw res.data.Errors;
            }
            this.cities = res.data;
            this.isLoading = false;
          });
      } catch (error) {
        console.log('location field', error);
      }
    },

    distanceModelUpdate() {
      this.$emit('distanceSelected', this.selectedRange);
    },
  },
};
</script>

<style lang="scss" scoped>
#range-select
  .v-text-field.v-text-field--solo.v-input--dense
  > .v-input__control {
  min-height: auto;
}

#range-select {
  position: absolute;
  z-index: 2;
  left: 15px;
  top: 1px;
  max-width: 100px;
  color: black;
  padding: 0px;
  border-right: 1px solid #ff7100;
  background-color: transparent;
}

#range-select .v-input__slot {
  padding: 0;
  z-index: 700;
}
</style>
